module.exports = __webpack_public_path__ + "img/guide_04.33a0bf24.png";